import React from 'react';
import type { Question, Language } from '@nordcrest/shared';

interface SingleSelectProps {
  question: Question;
  value: string | null;
  onChange: (value: string) => void;
  language: Language;
  error?: string;
}

export function SingleSelect({ question, value, onChange, language, error }: SingleSelectProps) {
  return (
    <div className="space-y-3">
      {question.options?.map((option) => (
        <button
          key={option.value}
          type="button"
          onClick={() => onChange(option.value)}
          className={`w-full text-left p-4 rounded-lg border-2 transition-all duration-200 ${
            value === option.value
              ? 'border-primary-500 bg-primary-50 ring-2 ring-primary-200'
              : 'border-gray-200 hover:border-primary-300 hover:bg-primary-50/50'
          }`}
        >
          <div className="flex items-center">
            <div
              className={`w-5 h-5 rounded-full border-2 mr-3 flex items-center justify-center ${
                value === option.value ? 'border-primary-500 bg-primary-500' : 'border-gray-300'
              }`}
            >
              {value === option.value && (
                <div className="w-2 h-2 rounded-full bg-white" />
              )}
            </div>
            <div>
              <span className="font-medium text-gray-900">{option.label[language]}</span>
              {option.description && (
                <p className="text-sm text-gray-500 mt-0.5">{option.description[language]}</p>
              )}
            </div>
          </div>
        </button>
      ))}
      {error && <p className="text-sm text-red-600 mt-2">{error}</p>}
    </div>
  );
}
